import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PopoverOffset50, PopoverOffsets } from "../../../../Constant";
import { OFFSET_DATA, OFFSET_LIST } from "../../../../Data/UiKit/Popover";
import { Btn } from "../../../../AbstractElements";
import Popovers from "../../../../CommonElements/Popover";
import CommonPopover from "../Common/CommonPopover";

const PopoverOffset = () => {
  const [popover, setPopover] = useState(false);
  const toggle = () => setPopover(!popover);
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={PopoverOffsets} span={OFFSET_DATA} />
        <CardBody className="common-flex popover-wrapper">
          <Btn color="secondary" className="example-popover mb-0 me-0" id="Popover-8">
            {PopoverOffset50}
          </Btn>
          <Popovers placement="right-start" isOpen={popover} target="Popover-8" toggle={toggle} title="Popover title">
            And here's some amazing content. It's very engaging. Right?
          </Popovers>
          {OFFSET_LIST.map((data, index) => (
            <CommonPopover key={index} item={data} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default PopoverOffset;
